export const CommunicationSystemKeys = {
  softwareVersion: 'softwareVersion',
  mvbStatus: 'mvbStatus',
  memoryUsage: 'memoryUsage',
  temperature: 'temperature',
  gsmError: 'gsmError',
  mvbError: 'mvbError',
  urukConnectionError: 'urukConnectionError',
  powerError: 'powerError',
  temperatureError: 'temperatureError',
  otherError: 'otherError',
  unitRole: 'unitRole',
  bcu: 'bcu',
  tcu: 'tcu',
  ccu: 'ccu',
  hmi: 'hmi',
  wtbMvb: 'wtb-mvb',
  eventRecorder: 'eventRecorder',
  canRiomError: 'canRiomError',
  mvbRiom1Error: 'mvbRiom1Error',
  mvbRiom2Error: 'mvbRiom2Error',
  mvbRiom3Error: 'mvbRiom3Error',
  mvbRiom4Error: 'mvbRiom4Error',
  papisError: 'papisError',
  cctvError: 'cctvError',
  driverHvacCommunicationError: 'driverHvacCommunicationError',
  hvac1CommunicationError: 'hvac1CommunicationError',
  hvac2CommunicationError: 'hvac2CommunicationError',
  isOuterDoor1CommunicationError: 'isOuterDoor1CommunicationError',
  isOuterDoor2CommunicationError: 'isOuterDoor2CommunicationError',
  isOuterDoor3CommunicationError: 'isOuterDoor3CommunicationError',
  isOuterDoor4CommunicationError: 'isOuterDoor4CommunicationError',
  isEndDoor1CommunicationError: 'isEndDoor1CommunicationError',
  isEndDoor2CommunicationError: 'isEndDoor2CommunicationError',
  isInnerDoor1CommunicationError: 'isInnerDoor1CommunicationError',
  isInnerDoor2CommunicationError: 'isInnerDoor2CommunicationError',
  isBistroDoorCommunicationError: 'isBistroDoorCommunicationError',
  toiletCommunicationError: 'toiletCommunicationError'
} as const;
